import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import './Navigation.css';

function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const accountPath = isAuthenticated ? '/dashboard' : '/login';
  const accountLabel = isAuthenticated ? 'Dashboard' : 'Login';

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path: string): string => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img className="nav-logo-image" src="/strata_logo.png" alt="Strata Software Group" />
        </Link>
        
        <button className="nav-toggle" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link to="/" className={`nav-link ${isActive('/')}`} onClick={() => setIsOpen(false)}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/products" className={`nav-link ${isActive('/products')}`} onClick={() => setIsOpen(false)}>
              Products
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/services" className={`nav-link ${isActive('/services')}`} onClick={() => setIsOpen(false)}>
              Services
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/portfolio" className={`nav-link ${isActive('/portfolio')}`} onClick={() => setIsOpen(false)}>
              Portfolio
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" className={`nav-link ${isActive('/about')}`} onClick={() => setIsOpen(false)}>
              About
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className={`nav-link nav-contact-btn ${isActive('/contact')}`} onClick={() => setIsOpen(false)}>
              Contact
            </Link>
          </li>
          <li className="nav-item">
            <Link to={accountPath} className={`nav-link nav-dashboard-btn ${isActive(accountPath)}`} onClick={() => setIsOpen(false)}>
              {accountLabel}
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
